module.exports = __webpack_public_path__ + "static/media/p008.a7f444c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p008.jpg
// module id = 1521
// module chunks = 0